import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '@/views/AdminDashboard.vue'
import Product from '@/views/Product.vue'
import Transaction from '@/views/Transaction.vue'
import Investment from '@/views/Investment.vue'
import Wallet from '@/views/Wallet.vue'
import Login from '@/views/Login.vue'
import Profile from '@/views/Profile.vue'
import ProductDetails from '@/views/ProductDetails.vue'
import Report from '@/views/Report.vue'
import Settings from '@/views/Settings.vue'
import Users from '@/views/User.vue'
import UserDetail from '@/views/UserDetails.vue'
import ProductType from '@/views/ProductType.vue'
import InterestType from '@/views/InterestType.vue'
import RiskCategory from '@/views/RiskCategory.vue'
import FeeConfiguration from '@/views/FeeConfiguration.vue'
import Partners from '@/views/Partners.vue'
import PartnerDetails from '@/views/PartnerDetails.vue'
import Roles from '@/views/Roles.vue'
import Permissions from '@/views/Permissions.vue'
import Admin from '@/views/Admin.vue'
import WithdrawalRequest from '@/views/WithdrawalRequest.vue'
import Banners from '@/views/Banners.vue'
import Campaign from '@/views/Campaign.vue'
import Referral from '@/views/Referral.vue'

const routes = [
    {
        path: '/',
        redirect: "/dashboard",
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, title: 'Dashboard' },  //checks if a user is logged in before allowing them in
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: { requiresAuth: true, title: 'Users' },
    },
    {
        path: '/partners',
        name: 'Partners',
        component: Partners,
        meta: { requiresAuth: true, title: 'Partners' },
    },
    {
        path: '/users/:id',
        name: 'UserDetails',
        component: UserDetail,
        meta: { requiresAuth: true, title: 'Details' },
    },
    {
        path: '/partners/:id',
        name: 'PartnerDetails',
        component: PartnerDetails,
        meta: { requiresAuth: true, title: 'Details' },
    },
    {
        path: '/products',
        name: 'Products',
        component: Product,
        meta: { requiresAuth: true, title: 'Products' },
    },
    {
        path: "/products/:id",
        name: "ProductDetails",
        component: ProductDetails,
        meta: { requiresAuth: true, title: 'Details' },
    },
    {
        path: "/product-types",
        name: "ProductType",
        component: ProductType,
        meta: { requiresAuth: true, title: 'Product Type' },
    },
    {
        path: '/transactions',
        name: 'Transactions',
        component: Transaction,
        meta: { requiresAuth: true, title: 'Transactions' },
    },
    {
        path: '/withdrawals',
        name: 'Withdrawals',
        component: WithdrawalRequest,
        meta: { requiresAuth: true, title: 'Withdrawals' },
    },
    {
        path: '/investments',
        name: 'Investments',
        component: Investment,
        meta: { requiresAuth: true, title: 'Investments' },
    },
    {
        path: "/interest-types",
        name: "InterestType",
        component: InterestType,
        meta: { requiresAuth: true, title: 'Interest Type' },
    },
    {
        path: "/risk-categories",
        name: "RiskCategory",
        component: RiskCategory,
        meta: { requiresAuth: true, title: 'Risk Categories' },
    },
    {
        path: '/wallets',
        name: 'Wallets',
        component: Wallet,
        meta: { requiresAuth: true, title: 'Wallets' },
    },
    {
        path: '/fees',
        name: 'FeeConfiguration',
        component: FeeConfiguration,
        meta: { requiresAuth: true, title: 'Fees Settings' },
    },
    {
        path: '/banners',
        name: 'Banners',
        component: Banners,
        meta: { requiresAuth: true, title: 'Banner Settings' },
    },
    {
        path: '/campaigns',
        name: 'Campaigns',
        component: Campaign,
        meta: { requiresAuth: true, title: 'Campaign Settings' },
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: { requiresAuth: true, title: 'Profile' },
    },
    {
        path: '/reports',
        name: 'Reports',
        component: Report,
        meta: { requiresAuth: true, title: 'Reports' },
    },
    {
        path: '/roles',
        name: 'Roles',
        component: Roles,
        meta: { requiresAuth: true, title: 'Roles' },
    },
    {
        path: '/permissions',
        name: 'Permissions',
        component: Permissions,
        meta: { requiresAuth: true, title: 'Permissions' },
    },
    {
        path: '/settings',
        name: 'Settings',
        component: Settings,
        meta: { requiresAuth: true, title: 'Settings' },
    },
    {
        path: '/admins',
        name: 'Admin',
        component: Admin,
        meta: { requiresAuth: true, title: 'Admin' },
    },
    {
        path: "/campaigns/:uuid/referrers",
        name: "referrers",
        component: Referral,
        meta: { requiresAuth: true, title: 'Referrals' },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { guestOnly: true }, //prevents logged in user from going back to login
    },
    // add more routes here
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  // ✅ store last visited route (only protected pages)
  if (to.meta.requiresAuth) {
    localStorage.setItem("lastRoute", to.fullPath);
  }

  // 🚨 redirect unauthenticated users
  if (to.meta.requiresAuth && !token) {
    next({ name: "Login" });
  }
  // 🚨 prevent logged-in users from seeing login/register
  else if (to.meta.guestOnly && token) {
    next({ name: "Dashboard" });
  }
   else {
    next();
  }
});

export default router
